import validators from '../validators';
import postValidators from '../postValidators';
import commonRoutingParameters from './commonRoutingParameters';
import utils from '../utils';
import parameterApplications from '../../common/parameterApplications';

/**
 * @private
 * @class CalculateReachableRangeParameters
 * @module Services
 */

let fields = {

    /**
     * Point from which the range calculation should start.
     *
     * @attribute origin
     * @param {String} origin Point from which the range calculation should start.
     * @throws {TypeError} If the given argument cannot be converted to a valid value.
     * @return {String} The method returns the current value.
     */
    origin: {
        validators: [validators.point],
        application: parameterApplications.PATH
    },

    /**
 * @attribute fuelBudgetInLiters
 * @param {Number} fuelBudgetInLiters Fuel budget in liters that
 *     determines the maximal range which can be traveled using the specified
 *     Combustion Consumption Model. Required if _vehicleEngineType_ is
 *     _combustion_.
 * @throws {TypeError} If the given argument cannot be converted to a
 *     valid value.
 * @return {String} The method returns the service instance allowing chaining or the current value if the
 *     argument is omitted.
 */
    fuelBudgetInLiters: {
        validators: [
            postValidators.requiredBudget,
            postValidators.requiredWithSpecificEngineType,
            postValidators.notCommon
        ]
    },

    /**
 * @attribute energyBudgetInkWh
 * @param {Number} energyBudgetInkWh  Electric energy budget in
 * kilowatt hours (kWh) that determines maximal range which can be
 * traveled using the specified Electric Consumption Model.
 * @throws {TypeError} If the given argument cannot be converted to a
 *     valid value.
 */
    energyBudgetInkWh: {
        validators: [
            postValidators.requiredBudget,
            postValidators.requiredWithSpecificEngineType,
            postValidators.notCommon
        ]
    },

    /**
 * @attribute timeBudgetInSec
 * @param {Number} timeBudgetInSec Time budget in seconds that determines maximal
 * range which can be traveled using driving time.
 * The consumption parameters will only affect eco-routes and thereby indirectly the driving time.
 * @throws {TypeError} If the given argument cannot be converted to a
 *     valid value.
 */
    timeBudgetInSec: {
        validators: [
            postValidators.requiredBudget,
            postValidators.notCommon
        ]
    }

};

fields = utils.extend(fields, commonRoutingParameters);

export default (fieldsToSkip) => {
    const result = utils.clone(fields);
    if (fieldsToSkip instanceof Array) {
        fieldsToSkip.forEach(function(field) {
            delete result[field];
        });
    }

    return result;
};




// WEBPACK FOOTER //
// ./services/services/routing/calculateReachableRangeParameters.js